module.exports = __webpack_public_path__ + "img/more.54019d79.svg";